module.exports = __webpack_public_path__ + "img/s2.3fd5c696.png";